var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loading)?_c('loading-indicator',{staticClass:"d-flex flex-center p-6",attrs:{"size":48}}):_c('job-request-view',{attrs:{"is-zipcode-chosen":_vm.isZipcodeChosen}})
}
var staticRenderFns = []

export { render, staticRenderFns }